import { DatabaseStreamState } from '../database-stream-state';

const streamState = DatabaseStreamState.getInstance();

// This is a no-op because the completion is handled by the createDatabase handler
// The reason we have this as a no-op is because sometimes the Rovo bridge sends the event prematurely
// before the createDatabase handler has had a chance to complete the streaming.
export const handleStreamCompleted = () => {};

export const handleStreamErrored = () => {
  streamState.completeStreaming();
};

export const handleStreamAborted = () => {
  streamState.completeStreaming();
};
